'use client'

import { ChevronUpIcon } from '@heroicons/react/20/solid'
import { getCookie } from 'cookies-next/client'
import { jwtDecode } from 'jwt-decode'
import { asyncSleep } from 'modern-async'
import { usePathname } from 'next/navigation'
import { useCallback, useEffect, useState } from 'react'
import { useWindowScroll } from 'react-use'
import { twMerge } from 'tailwind-merge'
import { cruzSocket } from '@/socket'
import { useGlobalStore } from '@/store/provider'
import type { Auth } from '@/types'

export default function RootLayoutClient() {
  const pathname = usePathname()
  // to initialize the global user state from the cookie
  const { user, setUser, setOnlineAdminUsers, setOnlineCruzUsers } = useGlobalStore((state) => state)

  useEffect(() => {
    if (!user?.email) {
      const token = getCookie('admin_id_token')
      if (token) {
        const decoded = jwtDecode(token)
        if (decoded) {
          setUser(decoded as Auth.AdminUser, pathname)
          socketEvents()
        }
      }
    }
  }, [])

  // path changed
  useEffect(() => {
    if (cruzSocket.socket) {
      cruzSocket.socket.emit('pathChanged', pathname)
    }
  }, [pathname])

  // socket events
  const socketEvents = useCallback(async () => {
    await asyncSleep(1)
    if (cruzSocket.socket) {
      // 1. online admin users
      cruzSocket.socket.on('onlineAdminUsers', (data: any) => {
        setOnlineAdminUsers(data)
      })
      // 2. online cruz users
      cruzSocket.socket.on('onlineCruzUsers', (data: Record<string, number>) => {
        setOnlineCruzUsers(data)
      })
    }
  }, [])

  return <BtnGoTop />
}

const BtnGoTop = () => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])
  const { y } = useWindowScroll()
  if (!isClient) return null
  return (
    <button
      type='button'
      className={twMerge(
        'p-3 fixed bottom-8 right-5 z-50 rounded-full shadow-lg',
        ' bg-zinc-900 hover:bg-zinc-700 text-white dark:bg-zinc-300 dark:hover:bg-zinc-400 dark:text-black',
        'transition duration-400 ',
        y > 200 ? 'opacity-100' : 'opacity-0',
      )}
      onClick={() => {
        window.scrollTo({ top: 0 })
      }}
    >
      <ChevronUpIcon className='size-10' />
    </button>
  )
}
